/**
 * Override console methods to send logs to the main thread for display in the UI.
 */

const originalConsoleLog = console.log;
const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;

console.log = (...args) => {
    postMessage({ type: 'log', message: args.join(' '), severity: 'log' });
    originalConsoleLog(...args);
};

console.warn = (...args) => {
    postMessage({ type: 'log', message: args.join(' '), severity: 'warn' });
    originalConsoleWarn(...args);
};

console.error = (...args) => {
    postMessage({ type: 'log', message: args.join(' '), severity: 'error' });
    originalConsoleError(...args);
};